import React from "react";

const StudentAchievementTimeline = ({ data }) => (

    <section
        className="student-achievement-timeline-section"
        id="achievement-timeline"
    >

        <div className="container">

            <div className="student-section-header">

                <span className="student-eyebrow">
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                    <span>{data.highlight}</span>
                </h2>

                <p>
                    {data.description}
                </p>

            </div>


            <div className="achievement-timeline">

                {(data.timeline || []).map((item, i) => (

                    <article
                        className="achievement-timeline-item"
                        key={i}
                    >

                        <div className="timeline-year">
                            {item.year}
                        </div>

                        <div className="timeline-content">

                            <span>
                                {item.program}
                            </span>

                            <h3>
                                {item.title}
                            </h3>

                            <p>
                                {item.description}
                            </p>

                            {item.link && (
                                <a
                                    href={item.link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {item.link.label}
                                </a>
                            )}

                        </div>

                    </article>

                ))}

            </div>


          

        </div>

    </section>
);

export default StudentAchievementTimeline;